import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { loadInfo, saveInfo } from './modules/localStorage'
import configureStore from './modules/store'
import throttle from 'lodash/throttle'
import { defaultState } from './app/reducers'

const persistedState = {
  app: {
    ...defaultState,
    ...loadInfo()
  }
}
const store = configureStore(persistedState)

store.subscribe(throttle(() => {
  saveInfo(store.getState())
}, 1000))

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
